import React                      from 'react'

import { TEXT
       , tr }                     from '../00_assets'
import { kde_api_client_contact_t
       , kde_api_client_contact_fields_t
       }                          from '../02_api'



export const CONTACT_LABEL =
  { email: TEXT.CLIENT_CONTACT_EMAIL
  , phone: TEXT.CLIENT_CONTACT_PHONE
  , fax: TEXT.CLIENT_CONTACT_FAX } ;


export const render_contact = ( row: { contact: kde_api_client_contact_t | null } ) =>
{
   const obj = row.contact ;

   return !obj?
      <span />
    : <span>
        { [ show_contact( obj, 'email' )
          , show_contact( obj, 'phone' )
          , show_contact( obj, 'fax'   ) ]
        .filter( data => data.text !== false )
        .map( contact => <div key={ contact.key }>{ contact.text }</div> ) }
      </span> ;
}

const show_contact = ( row: any, what: kde_api_client_contact_fields_t ) => 
     ({ key: what
      , text: 
        row[ what ]?
          show_field( tr( CONTACT_LABEL[ what ] ), row[ what ] )
        : false })


export const show_field = ( what: string, value: any ) =>
  what.length? what + ': ' + value : value ;



